import { render, staticRenderFns } from "./FormBasic.vue?vue&type=template&id=913648a6&scoped=true&"
import script from "./FormBasic.vue?vue&type=script&lang=js&"
export * from "./FormBasic.vue?vue&type=script&lang=js&"
import style0 from "./FormBasic.vue?vue&type=style&index=0&id=913648a6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "913648a6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/user/workspace/securamdata/sca-app-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('913648a6')) {
      api.createRecord('913648a6', component.options)
    } else {
      api.reload('913648a6', component.options)
    }
    module.hot.accept("./FormBasic.vue?vue&type=template&id=913648a6&scoped=true&", function () {
      api.rerender('913648a6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/apps/newsletter/workflow/FormBasic.vue"
export default component.exports